import axios from 'axios'

const state = {
  appTranslations: {},
}

const mutations = {
  appTranslations_data (state, appTranslations) {
    state.appTranslations = appTranslations
  },
}

const actions = {
  getAppTranslations ({ commit }, code) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appTranslations?code=' + code,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          commit('appTranslations_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
